<ng-template #contentTpl><ng-content></ng-content></ng-template>

<aside
  *ngIf="!isOverlayOpen"
  class="sidebar"
  [ngClass]="['sidebar--' + color, isShrink ? 'sidebar--shrink' : '']"
  (mouseenter)="onMouseEnterSidebar()"
  (mouseleave)="onMouseExitSidebar()"
>
  <ng-scrollbar #sidebarScrollbar data-cy="scrollbar" class="scrollbar" visibility="hover">
    <div class="navigation">
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </div>
  </ng-scrollbar>

  <ms-dashboard-sidebar-footer [color]="color"></ms-dashboard-sidebar-footer>
</aside>

<div *ngIf="isOverlayOpen" (click)="closeOverlay()" class="overlay-wrapper">
  <div @slide class="overlay" [ngClass]="['overlay--' + color]" (click)="$event.stopPropagation()">
  <ng-scrollbar #overlayScrollbar data-cy="scrollbar" class="scrollbar" visibility="hover">
      <div class="navigation">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
      </div>
    </ng-scrollbar>

    <ms-dashboard-sidebar-footer [color]="color"></ms-dashboard-sidebar-footer>
  </div>
</div>

<!-- <div data-cy="toggle-expander" class="expander-box" (click)="toggleExpander()">
  <div class="expander-wrapper">
    <div class="expander" [ngClass]="['expander--' + color]">
      <div class="expander-icon-wrapper" [ngSwitch]="mode">
        <i *ngSwitchCase="'normal'" class="expander-icon fas fa-chevron-left"></i>
        <i *ngSwitchCase="'shrink'" class="expander-icon fas fa-chevron-right"></i>
      </div>
    </div>
  </div>
</div> -->
